module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-114x114-0039bf72858b8812206b597d671af473.png";